import React from "react";
import { PatientHeaderDescription } from "../../../../message/messageHeader/patientGroupHeader/PatientHeaderDescription";
import { GROUP_AVATAR_SIZE } from "../../../../utils/AvatarUtils";
import {
  AddressDivider,
  AddressText,
  AddressWrapper,
  PinContentStyle,
} from "./AdvanceSearchMap.style";
import { useTranslation } from "hhn-commons";
import { IPatientHeaderProps } from "../AdvanceSearchHelper";

export const PatientPinContent = ({
  patientHeaderProps,
}: {
  patientHeaderProps: IPatientHeaderProps;
}) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "advanceSearch" });
  return (
    <PinContentStyle data-testid="patient-pin-content">
      <PatientHeaderDescription
        avatarSize={GROUP_AVATAR_SIZE.SMALL}
        name={patientHeaderProps.name}
        patientStatus={patientHeaderProps.patientStatus}
        servicesToPatient={patientHeaderProps.servicesToPatient}
        meta={patientHeaderProps?.meta}
      />
      <AddressDivider variant="middle" />
      <AddressWrapper variant="caption" data-testid="patient-address">
        <AddressText>{tNs("address")}</AddressText>
        {patientHeaderProps.address.placeName}
      </AddressWrapper>
    </PinContentStyle>
  );
};
